<script>
    import { metaInfo } from "@/core/MetaInfo";
    import GuaranteeContent from "@/components/GuaranteeContent";
    import GuaranteeList from "@bivan/components/GuaranteeList";

    export default {
        name: "Guarantee",
        components: {
            GuaranteeContent,
            GuaranteeList,
        },
        metaInfo() {
            return metaInfo.getMeta("guarantee");
        },
    };
</script>

<template>
    <div class="l-container">
        <guarantee-content email="support@bivan.ru"></guarantee-content>

        <div class="b-text-page__guarantee">
            <guarantee-list></guarantee-list>
        </div>
    </div>
</template>
